export type DataUploadProviderConfig = {
  id: number;
  code: string;
  template_s3_key?: string | null;
};

export function getSelectedConfig<T extends DataUploadProviderConfig>(
  configs: T[],
  selectedConfigCode: string | null,
): T | undefined {
  if (!selectedConfigCode) {
    return undefined;
  }

  return configs.find((config) => config.code === selectedConfigCode);
}

export function getTemplateFileName(
  templateS3Key?: string | null,
  fallback = "template",
): string {
  const fileName = templateS3Key?.split("/").slice(-1)[0];
  return fileName || fallback;
}
